<script>
	// Stores
	import MeetingStore from '@/Stores/Racing/MeetingStore';
	import ACLStore from '@/Stores/ACLStore.js';
	// Services
	import { notify } from '@/Services/Notify.js';
	// Components
	import Modal from '@/Components/ModalFlex.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';

	export let meeting = undefined;
	export let open = false;

	let sending = false;

	window.scrollTo(0, 0);

	$: currentMeetingFees = meeting && meeting.fees;
	$: newMeetingFees = currentMeetingFees;

	function updateMeetingFees() {
		sending = true;
		meeting
			.update({
				fees: newMeetingFees
			})
			.then(() => {
				notify({
					type: 'success',
					title: meeting.name,
					message: 'Meeting fees successfully updated',
					timeout: 3
				});
				MeetingStore.getMeetingWithRaces(meeting.id);
				open = false;
			})
			.catch((e) => {
				notify({
					type: 'danger',
					title: 'Error!',
					message: (e.error && e.error[0]) || 'Failed to alter meeting fees',
					timeout: 5
				});
			})
			.finally(() => (sending = false));
	}
</script>

{#if open && $ACLStore && ACLStore.granted('competitions.update.fees')}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 mb-2 text-xl font-bold text-center">Adjust Meeting Fees</h2>
		<div class="pt-1 text-center">{meeting.name}</div>
		<div class="flex justify-center py-2 space-x-4">
			<p>
				Current Meeting Fees: {currentMeetingFees}%
			</p>
		</div>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<div class="flex flex-row mb-2 justify-center items-center">
				<div>New Meeting Fees:</div>
				<TextInput
					name={'new_meeting_fees'}
					type="number"
					required={true}
					className="text-left ml-3"
					step="0.01"
					on:change={(event) => (newMeetingFees = parseFloat(event.target.value))}
					on:keyup={(event) => {
						if (event.keyCode === 13) {
							newMeetingFees = parseFloat(event.target.value);
						}
					}}
					value={newMeetingFees}
				/>
			</div>
			<LoadingButton on:click={updateMeetingFees} loading={sending} className="mb-4 btn btn-primary-action"
				>Update
			</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click|preventDefault={() => (open = false)}> Cancel</button>
		</div>
	</Modal>
{/if}
